/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    value: 'Valor',
    ok: 'Entendido',
  },
  creators: {
    seeViewBy: 'Ver vista por:'
  },
  lang: {
    changeMessage: 'Adaptamos el contenido al idioma seleccionado.',
  },
  anteroom: {
    startSeriesFor: 'Comenzar serie por:',
    startSeasonFor: 'Comenzar temporada {{seasonNumber}} por:',
  },
  translations: {

    /**
     * COMMON
     */
    goToHome: "Ir al inicio",
    spanish: "Español",
    english: "Inglés",
    enterEmail: "Ingresá tu e-mail",
    creators: "Creadores",
    watchNow: "Ver ahora",
    download: "Descargar",
    downloadApp: 'Descargá la app',
    back: "Atrás",
    series: "SERIES",
    community: "COMUNIDAD",
    logout: "CERRAR SESIÓN",
    episode: "EPISODIO",
    min: "min",
    faqs: "Preguntas frecuentes",
    o: 'o',
    accept: 'Aceptar',
    cancel: 'Cancelar',
    language: 'Idioma',
    content: 'Contenido',
    contents: 'Contenidos',
    linkCopied: 'Link copiado',

    /**
     * MODAL
     */
    modal_enjoyYourContent_title: "Disfrutá tu contenido",
    modal_enjoyYourContent_content: "Conocé todas las funcionalidades en nuestra app.",
    modal_spendFlixx_title: "Gastá tus Flixx",
    modal_spendFlixx_content: "Conocé todas las funcionalidades en nuestra app.",
    scanCodeQR: "Escanea el código QR y accede a Flixxo",
    fromYourMobilePhone: "desde tu teléfono móvil.",
    availableOn: "Disponible en",
    liveFullExperience: "¡Viví la experiencia completa!",

    /**
     * FLIXX
     */
    useFlixx: "Guarda tus Flixx y utilizalos fuera de la app",
    buySellFlixx: "Compra y vende tus flixx. transformalos en bitcoin o en tu moneda",
    earnFlixx: "Ganá Flixx",
    earnFlixxDescription: "Distribuyendo contenido o mirando publicidad cuando lo desees.",
    spendFlixx: "Gastá Flixx",
    spendFlixxDescription: "Mira el contenido que realmente querés ver.",
    withdrawFlixx: "Retirá Flixx",
    withdrawFlixxDescription: "Transformándolos en tu moneda preferencial y utilizalos fuera de la App.",
    howMuchFlixx: "¿Cuánto vale un Flixx?",
    flixxDescription: "Las fichitas son tan de los ´80… pero en Flixxo están otra vez de moda. Tomamos prestada la tecnología de Bitcoin para desarrollar Flixx nuestra propia moneda digital. Ganalos, gastalos para ver videos, trasferíles a un amigo o cambialo por Bitcoin o por la moneda de tu país. Flixx es tuyo y tiene valor dentro y fuera de nuestra app.",

    /**
     * FOOTER
     */
    whatIsFlixx: "¿Qué es un Flixx?",
    termsAndConditions: "Términos y condiciones",
    policyPrivacy: "Políticas de Privacidad",

    /**
     * SEARCH
     */
    "search-placeholder": "Buscar en Flixxo",
    "search-results": "Tus resultados para:",
  
    /**
     * MOODS
     */
    "mood-cry": "Llorar",
    "mood-fall": "Enamorarse",
    "mood-laugh": "Reir",
    "mood-imagine": "Imaginar",
    "mood-scream": "Gritar",
    "mood-think": "Pensar",
    moodsDescription: 'Explora el contenido filtrando por estado de ánimo',

    /**
     * NEW MESSAGES
     */
    retry: 'Reintentar',
    loginPlaceholder: 'E-mail o usuario',
    openApp: 'ABRIR EN LA APLICACIÓN',
    backToPlay: 'Volver a Play Flixxo',
    goToCreators: 'Ir a Flixxo Creators',
    showDetail: 'Ver detalle',
    sendCode: 'Obtener código',
    enterPhone: 'Ingresa tu numero de telefono',
    enterCode: 'Ingresa aqui el código',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmá tu contraseña',
    didNotGetCode: '¿No te llegó el código?',
    sendAgain: 'Volver a enviar',
    enter: 'Ingresar',
    episodes: 'episodios',
    bought: 'Comprado',
    watchFor: 'Ver por',
    watchSE: 'Ver T{{season}} E{{episode}}',
    season: 'Temporada',
    seasons: 'Temporadas',
    subtitles: 'Subtítulos',
    audio: 'Audio',
    video: 'Video',
    videos: 'Videos',
    showMore: 'Ver más',
    showLess: 'Ver menos',
    disabledPlural: 'Desactivados',
    nextEpisode: 'Próximo episodio',
    starting: 'Comenzando',
    continueWatching: "Continuar viendo",
    didYouEnterWrongNumber: '¿Ingresaste un número incorrecto?',
    selectOption: 'Seleccionar una opción',
    next: 'Siguiente',
    timeAgo: 'Hace {{number}} {{unit}}',
    enjoyFullExperience: 'Disfruta de la experiencia completa en nuestra app',
    open: 'Abrir',
    continueOnBrowser: 'Continuar en el navegador',

    statistics: 'Estadísticas',
    newFollowers: 'Nuevos Seguidores',
    status: "Estado",
    releaseDate: 'Estreno',
    purchases: 'Compras',
    earnings: "Ganancias",
    price: "Precio",

    /**
     * MODALS WELCOME, LOGIN, REGISTER, RECOVERY
     */
    welcomeToFlixxo: '¡Bienvenido a Flixxo!',
    discoverBestMicroseries: 'Descubrí las mejores microseries del mundo,',
    free: 'gratis.',
    enterWith: 'Ingresá con',
    alsoYouCan: 'O tambien podés',
    login: 'Iniciar sesión',
    loggingIn: 'Iniciando sesión...',
    createAccount: 'Crear cuenta',
    creatingAccount: 'Creando cuenta...',
    goodToSeeYouAgain: '¡Que bueno verte otra vez!',
    fillInYourDetails: 'Completá tus datos para ingresar.',
    usernameOrEmail: 'Usuario o e-mail',
    password: 'Contraseña',
    forgotMyPassword: 'Olvidé mi contraseña',
    firstTimeInFlixxo: '¿Primera vez en Flixxo?',
    createYourAccount: 'Creá tu cuenta',
    recoverPassword: 'Recuperar contraseña',
    recoveringPassword: 'Recuperando contraseña...',
    enterYourMobileNumber: 'Ingresá tu número de celular',
    mobileNumber: 'Número de celular',
    mobileInfo: 'Te solicitamos tu número de teléfono para contar con un segundo factor de seguridad al recuperar una contraseña.',
    passwordsDoesntMatch: 'Las contraseñas que ingresaste no coinciden.',
    enterCodeAndCreateNewPwd: 'Ingresá el código que te enviamos y creá la nueva contraseña',
    resendCode: 'Reenviarme el código',
    repeatPassword: 'Repetir contraseña',
    passwordReqs: 'Debe contener al menos una minúscula, una mayúscula y un número. Mínimo 8 caracteres, máximo 30.',
    passwordRecoverySuccessfull: '¡Recuperaste tu contraseña exitosamente!',
    nowYouCanLoginWithNewPwd: 'Ya podés iniciar sesión con la nueva contraseña',
    great: 'Genial',
    enterEmailAndCreateNewUsername: 'Ingresá un e-mail y creá un usuario',
    email: 'E-mail',
    username: 'Nombre de usuario',
    usernameReq_1: 'El nombre de usuario debe contar entre 3 y 16 caracteres.',
    usernameReq_2: 'El nombre de usuario debe contener al menos 1 letra.',
    termsAndConditions_1: 'Al continuar confirmás nuestros ',
    termsAndConditions_2: 'términos y condiciones',
    termsAndConditions_3: ', las ',
    termsAndConditions_4: 'políticas de privacidad',
    termsAndConditions_5: ' y que sos mayor de 13 años.',
    alreadyHaveAnAccount: '¿Ya tenes cuenta?',
    loginImperative: 'Iniciá sesión',
    createPassword: 'Creá una contraseña',
    mustContainOneLowerCase: 'Debe contener al menos una minúscula',
    mustContainOneUpperCase: 'Debe contener al menos una mayúscula',
    mustContainOneNumber: 'Debe contener al menos un número',
    lengthMinMax: 'Mínimo {{min}} caracteres, máximo {{max}}',
    congratsHaveCreatedAnAccount: '¡Felicitaciones! \n Creaste tu cuenta en Flixxo',
    nowYouAreFlixxer: '¡De ahora en más sos Flixxer! 🤘',
    validateAccount: 'Validar cuenta',
    validatingAccount: 'Validando cuenta...',
    finishAccountValidation: 'Finalizá la validación de tu cuenta ingresando tu número de celular',
    enterCodeSentTo: 'Ingresá el código enviado al:\n{{mobileNumber}}',
    recaptchaStatement_1: 'Este sitio está protegido por reCAPTCHA y se aplican las',
    recaptchaStatement_2: 'Políticas de privacidad',
    recaptchaStatement_3: 'y los',
    recaptchaStatement_4: 'Términos de servicio',
    recaptchaStatement_5: 'de Google.',

    /**
     * FAQS
     */
    answersToCommonQuestions: 'Respuestas a las preguntas más frecuentes.',

    whatIsFlixxo: '¿Qué es Flixxo?',
    whatIsFlixxo_1: 'Flixxo es una plataforma de microseries de todo el mundo. El modelo de distribución y monetización en Flixxo es diferente a todo lo que existe, ya que permite:',
    whatIsFlixxo_2: 'A los espectadores:',
    whatIsFlixxo_3: 'Que tengan una alternativa para',
    whatIsFlixxo_4: ' encontrar nuevas voces y contenidos independientes y originales',
    whatIsFlixxo_5: ', es decir, que no dependan del algoritmo.',
    whatIsFlixxo_6: 'Que puedan ver en poco tiempo, buenas historias.',
    whatIsFlixxo_7: 'A los creadores:',
    whatIsFlixxo_8: 'Que puedan',
    whatIsFlixxo_9: ' monetizar de manera instantánea y transparente.',

    whatKindOfContent: '¿Qué tipo de contenido encuentro en Flixxo?',
    whatKindOfContent_1: 'Hoy en Flixxo vas a encontrar diversidad de microseries de creadores emergentes e independientes que descubrimos en festivales de todo el mundo. Nuestra curaduría está enfocada en las nuevas voces creativas de todos los géneros.',
    whatKindOfContent_2: 'Las microseries son series de cualquier género, en las que cada episodio dura entre 1 y 15 minutos',

    howDoIAccess: '¿Cómo accedo a mirar microseries en Flixxo?',
    howDoIAccess_1: 'Fácil.',
    howDoIAccess_2: ' ¡Registrate gratis en la web o en la App (',
    howDoIAccess_3: ' ) y mirá el contenido que te guste!',

    FlixxoIsFree: '¿Flixxo es gratis?',
    FlixxoIsFree_1: '¡Sí! En Flixxo',
    FlixxoIsFree_2: ' podés mirar microseries de manera gratuita.',
    FlixxoIsFree_3: 'También hay una alternativa para quienes no quieran ver anuncios: cargar flixx en la wallet',
    FlixxoIsFree_4: ' (Sólo disponible en App de',
    FlixxoIsFree_5: ' ).',

    whatAreFlixx: '¿Qué son los Flixx?',
    whatAreFlixx_1: 'Flixx es la criptomoneda de nuestra comunidad. Gracias a que usamos el Flixx es posible que los creadores moneticen de manera directa, transparente y descentralizada cada vez que mirás sus contenidos.',
    whatAreFlixx_2: 'Cada vez que mirás un contenido, el creador recibe tus Flixx.',
    whatAreFlixx_3: 'Cada vez que mirás un anuncio, vos recibís Flixx.',
    whatAreFlixx_4: 'Cuando cumplís desafíos, te recompensamos con Flixx.',
    whatAreFlixx_5: 'Podés realizar transferencia de Flixx a otros usuarios. ',
    whatAreFlixx_6: 'Podés donar Flixx a creadores de contenido.',
    whatAreFlixx_7: 'También podes comprar Flixx en exchanges como',
    whatAreFlixx_8: ' y cargarlos en tu wallet',
    whatAreFlixx_9: 'Conocé más sobre el Flixx',

    flixxGoToCreator: '¿Mis Flixx van directo al creador?',
    flixxGoToCreator_1: 'Ajá. Cada vez que mirás un contenido, el creador recibe tus Flixx de manera instantánea, transparente... ¡y sin intermediarios!',

    canUploadMyContent: 'Soy creador, ¿puedo subir mi contenido a Flixxo?',
    canUploadMyContent_1: 'Claro. Vení, te contamos todo.',

    whatFlixxoMakesDifferent: '¿Qué nos diferencia de otras plataformas?',
    whatFlixxoMakesDifferent_1: 'Contenidos de corta duración',
    whatFlixxoMakesDifferent_2: 'Apoyo transparente y directo al creador de contenido',
    whatFlixxoMakesDifferent_3: 'Impulsor de creadores emergentes e independientes al mercado',
    whatFlixxoMakesDifferent_4: 'Ecosistema creativo entre creadores y espectadores',
    whatFlixxoMakesDifferent_5: 'Sistema de recompensas',
    whatFlixxoMakesDifferent_6: 'Libres de algoritmo',

    flixxoProduces: '¿Flixxo produce?',
    flixxoProduces_1: 'Los',
    flixxoProduces_2: ' Flixxo Originals',
    flixxoProduces_3: ' son los contenidos producidos por Flixxo. Desde Flixxo Distribution, apoyamos a las creaciones de más de 30',
    flixxoProduces_4: ' creadores 3.0',
    flixxoProduces_5: ' de todo el mundo, y las promovemos en mercados internacionales, buscando nuevas plataformas para su distribución.',

    whatAreCreators3: '¿Qué son los Creadores 3.0?',
    whatAreCreators3_1: 'Creadores 3.0 son los protagonistas de un nuevo paradigma de creatividad colaborativa y descentralizada, propias de la tecnología y cultura de la web 3.0.',
    whatAreCreators3_2: 'El valor fundamental de la web 3.0 es la descentralización, es decir, que no haya un intermediario poniendo las reglas. Esto le devuelve el poder al creador de contenidos para monetizar de forma directa.',

    haveDoubts: '¿Te quedaron dudas?',
    faqs_contactUs: "contactate con nosotros",

    /**
     * SEO
     */
    seoSeriesTitle: 'Series',
    seoSeriesDescription: 'Microseries originales del mundo',
    seoCommunityTitle: 'Comunidad',
    seoCommunityDescription: 'Videos y contenidos cortos de la comunidad Flixxo',
    seoSearchTitle: 'Búsqueda',
    seoSearchDescription: 'Buscá los mejores contenidos y videos cortos en Flixxo',
    seoDefaultTitle: 'Flixxo',
    seoDefaultDescription: 'Microseries y videos cortos al estilo de la web3',
    seoBeCreatorTitle: 'Convertite en creador',
    seoBeCreatorDescription: 'Acompañamos a creadores independientes de todo el mundo en la producción y distribución de su microserie.',
    seoFlixxTitle: 'Flixx, nuestra criptomoneda',
    seoFlixxDescription: 'Flixx es la criptomoneda de Flixxo, con la que vas a poder ver microseries grátis y bancar a sus creadores.',

    /**
     * CREATORS
     */
    fromBeginning: 'Desde el inicio',
    last30Days: 'Últimos 30 días',
    last7Days: 'Últimos 7 días',
    fromBeginningPhrase: `Desde que subiste tu primer contenido`,
    periodPhrase: `Desde el {{ start }} hasta el {{ end }}`,
    allContent: 'Todo el contenido',

    noSearchResults: 'No hay resultados para tu búsqueda',
    noSearchResultsDescription: 'Intenta escribiendo de otra manera o busca otro de tus contenidos',
    noContentYet: 'Todavía no tenés ningún contenido',
    noContentYetDescription: 'Comenzá a subir contenido y empieza a crear todo tu público',
    noInternet: 'No tienes conexión a internet',
    noInternetDescription: 'Intenta revisar tu conexión y luego prueba recargando la página',
    serverError: 'Hubo un problema con el servidor',
    serverErrorDescription: 'Prueba recargando la página',

    searchYourVideo: 'Buscá tu video...',
    viewOnFlixxo: 'Ver en Flixxo',
    published: 'Publicado',
    deleted: 'Eliminado',
    paused: 'Pausado',
    unknown: 'Desconocido',

    seasonEpisode: 'T{{season}}E{{episode}}',
    earningsTooltip: 'De tus ingresos (compras), una parte se utiliza para apoyar a la Comunidad.',
    yourContentIsPaused: 'Tu contenido está pausado',
    knowMoreAboutContent: 'Si queres saber más acerca de este contenido escribinos a content@flixxo.com',
    sendUsYourQuestion: 'Escribinos tu consulta',

    /**
     * ERROR MESSAGES
     */
    contentNotFound: 'El contenido que estás buscando no existe',
    wrongCredentials: 'Usuario, e-mail o contraseña incorrecta.',
    emailRegistered: 'El e-mail que ingresaste ya está registrado.',
    emailInvalid: 'El e-mail que ingresaste no posee un formato válido.',
    usernameRegistered: 'El usuario que ingresaste ya está registrado.',
    passwordsDontMatch: 'Las contraseñas que ingresaste no coinciden',
    mobileNumberInvalid: 'El número que ingresaste no es válido',
    mobileNumberRegistered: 'El número que ingresaste ya está registrado',
    mobileNumberUnknown: 'El número ingresado no pertenece a ningún usuario registrado',
    codeInvalid: 'El código que ingresaste no es válido',
    operationLimitExceeded: 'Superaste la cantidad de intentos permitidos. Por favor intentá de nuevo más tarde.',
    notPossibleLogInThisAccount: 'No es posible iniciar sesión con esta cuenta.',

    /**
     * Onboarding Anteroom
     */
    flixxoIsFree: '¡Flixxo es gratis!',
    contentPricedInFlixx: 'Todos los contenidos tienen un valor en (*)Flixx(/*)',
    ifDontOwnFlixxWillPlayAd: `Si no tenés Flixx, (*)se reproducirá un anuncio previo a ver el contenido.(/*)`,
    earnFlixxInChallengesSection: 'Descargate la app para conocer más formas de ganar Flixx.',

    /**
     * Be Creator
     */
    creator: 'Creador',
    beCreator: 'Quiero ser creador 3.0',
    letsBoostYourMicroseries_1: 'Impulsemos tu microserie,',
    letsBoostYourMicroseries_2: 'cerca de tu comunidad.',
    weSupportCreators: 'Acompañamos a creadores independientes de todo el mundo en la producción y distribución de su contenido.',
    globalMicroseries: '(*)Microseries(/*) de cualquier parte del mundo.',
    independentCreators: '(*)Creadores independientes(/*) que se animan a desafiar el paradigma.',
    diverseContents: '(*)Contenidos diversos(/*) de distintos temas y géneros.',
    weAdviceYou: '(*)Te asesoramos(/*) para que tu contenido cumpla altos estándares.',
    canExpandYourReach: '(*)Te impulsamos(/*) para que alcances otros mercado y plataformas.',
    yourContentYourRules: '(*)Tu contenido, tus reglas.(/*) Te acompañamos en tu visión.',
    flixxoWelcomesYou: 'En Flixxo, sos bienvenido.',
    firstWeHugYou: 'Comprendemos el valor y potencial que hay en los contenidos independientes, es por eso, que lo primero que vas a recibir en Flixxo es un abrazo. De ahí en más nuestra misión es acompañarte.',
    reachOutToUs: 'Contactáte con nosotros',
    showUsYourMicroseries: 'Presentanos tu microserie.',
    addYourMicroseries: 'Publicamos tu microserie',
    workTogetherToPublish: `Una vez que recibimos tu microserie, trabajamos juntos para publicarla.`,
    monetizeEachView: 'Monetizá con cada compra',
    earnFlixxWithNoIntermediaries: `Cada vez que alguien compra un contenido tuyo, ganás Flixx. Los recibís de manera directa, sin intermediarios.`,
    beProtagonist: 'Sé el protagonista de tu contenido y de tu comunidad.',
    becomeCreator: 'Convertite en un creador 3.0',
    earnFlixxWithContentAccess: 'Cada vez que un usuario compra tu contenido, ganás Flixx.',
    receiveFlixxInYourAccount: 'El Flixx es la criptomoneda de Flixxo. Cada vez que alguien compra tu contenido recibís los Flixx directo a tu cuenta.',
    yourContent: 'Tu contenido',
    followUpInteractions: 'Seguí de cerca las interacciones de tu contenido de manera desglosada.',
    yourEarnings: 'Tus ganancias',
    reviewAndFilterEarnings: 'Analizá la evolución de tus ganancias totales o por períodos específicos.',
    readyToBecomeCreator: '¿Estás listo para convertirte en un creador 3.0?',
    anyQuestions: '¿Te quedaron preguntas? Seguro las respondimos en nuestras',
    creatorTextChat: `Hola Flixxo! tengo una microserie y un cortometraje que me gustaría publicar en su plataforma \uD83E\uDD0D`,
    flixxoTextChat: 'Hola creador, genial! nos encanta recibir propuestas. Trabajemos juntos para publicarla lo antes posible en Flixxo.',

    /**
     * AD PLAYER
     */
    ad_title: 'Mirando el anuncio ganás',
    ad_description: 'Luego el creador recibirá los flixx por el valor del episodio y comenzará el contenido',

    /**
     * CONTENT PLAYER
     */
    creatorReceivingFlixx: 'El creador está recibiendo los flixx...',
    reproductionWillStartSoon: 'La reproducción comenzará en breve...',
    seasonEpisodeHyphen: 'T{{season}}-E{{episode}}',

    /**
     * FLIXX
     */
    flixx_hero_whatIsFlixx: 'Flixx es la moneda de Flixxo',
    flixx_hero_description: 'Con el Flixx vas a poder ver microseries gratis y bancar a los creadores. Tomamos prestada tecnología del Bitcoin para desarrollar nuestra propia criptomoneda y asegurarnos una monetización justa y transparente. Los Flixx son tuyos, de los creadores, de toda nuestra comunidad, y tienen valor dentro y fuera de nuestras apps',
    flixx_hero_imFlixx: 'Hola! Yo soy Flixx',
    flixx_watchAd_title: 'Mirá un anuncio previo a la reproducción de un contenido.',
    flixx_watchAd_description: 'El anunciante te paga a vos por tu tiempo de atención.',
    flixx_watchAd_exampleTitle: 'Mirando el anuncio ganás',
    flixx_watchAd_exampleDescription: 'Luego el creador recibirá los Flixx por el valor del episodio y comenzará el contenido',
    flixx_challenges_title: 'Completá desafíos.',
    flixx_challenges_description: 'Descubrí creadores nuevos, invitá amigos, mirá series completas para ganar los desafíos y recibir más Flixx (para acceder a los desafíos <0>descargate la App</0>).',
    flixx_challenges_exampleTitle: 'El primero de muchos...',
    flixx_challenges_exampleDescription: 'Como bienvenida, te regalamos Flixx por tu primer contenido visto',
    flixx_challenges_examplePrize: 'Premio',
    flixx_challenges_exampleCTA: 'Reclamar recompensa',
    flixx_transfers_title: 'Recibí Flixx de otros usuarios en tu billetera. ',
    flixx_transfers_description: 'Envíá y recibí Flixx sin límites, podés donarle Flixx a un creador o recibir Flixx de un amigo. ¡No tenés que tener conocimientos previos sobre criptomonedas! (Para acceder a tu billetera <0>descargate la App</0>).',
    flixx_transfers_exampleName: 'Alejo',
    flixx_transfers_exampleDate: '2023-2-16',
    flixx_buy_title: 'Comprá Flixx en un exchange.',
    flixx_buy_description: 'Desde <0>Uniswap</0>, <1>Bittrex</1>, <2>Bancor</2> podés comprar y transferir Flixx a tu billetera.',
    flixx_doubts_title: '¿Te quedaron dudas sobre el Flixx?',
    flixx_doubts_1_title: '¿Puedo ver episodios sin tener Flixx?',
    flixx_doubts_1_description: '(*)Sí. Al momento de reproducir un episodio, si no tenés Flixx, verás un anuncio. (/*)Cada anuncio te paga un monto en Flixx que te permite ver el episodio y bancar al creador, quien recibirá parte de esos Flixx de manera instantánea y transparente.',
    flixx_doubts_2_title: '¿Cuál es el valor en Flixx que tienen los episodios?',
    flixx_doubts_2_description: 'Actualmente los episodios tienen un valor de 0,50 hasta 1 Flixx. El anuncio que se reproduce previo al episodio cubre la totalidad del valor en Flixx del mismo.',
    flixx_doubts_3_title: '¿Cuál es la cotización del Flixx?',
    flixx_doubts_3_description: 'Podés ver la cotización del Flixx en <0>CoinMarketCap</0>',
    flixx_doubts_4_title: '¿Por qué Flixxo utiliza Flixx?',
    flixx_doubts_4_description: 'Utilizar nuestra criptomoneda nos permitió crear un ecosistema transparente e inmediato, donde el intercambio de Flixx va sin intermediarios del anunciante al espectador y del espectador al creador.',
    flixx_doubts_faqs: '¿Te quedaron dudas? <0>Contactate con nosotros</0>',
  },
};
